<template>
	<b-container class="no-padding">
		<b-row>
			<b-col>
				<b-form-group
					label-for="query">
					<b-form-input
						id="query"
						type="text"
						placeholder="Anbieter suchen ..."
						v-model.trim="query"
						v-on:input="searchItem">
					</b-form-input>
				</b-form-group>	
			</b-col>
			<b-col>
				<div 	class="resultBox selectedPersons">
					<div class="container-fluid">
						<span v-if="selectedItemObject !== ''">Anbieter</span>
						<div v-if="selectedItemObject !== ''" class="space10"></div>
						<b-list-group v-if="selectedItemObject !== ''">
							<b-list-group-item 	v-if="selectedItemObject !== ''"
												class="list-group-item-selected"
												key="0">
								<span style="float: left;"><img alt="logo" class="brand-image-thumb" v-bind:src="selectedItemObject.brandImage.secure_url">{{ selectedItemObject.name }}</span>
								<span class="icon-check" style="float: right;"></span>
							</b-list-group-item>
						</b-list-group>
						<div v-else class="text-center">
								Kein Anbieter ausgewählt.
							<div class="break-10"></div>
						</div>
													
						<div v-if="query !== ''">
							<div class="space20"></div>
							<span>Suchergebnisse</span>	
							<div class="space10"></div>					
							<b-list-group v-if="foundItems.length > 0">
								<b-list-group-item	v-for="(provider, index) in foundItems"
													v-on:click="toggleSelect(provider)"
													v-bind:key="index+1">
									<span style="float: left;"><img alt="logo" class="brand-image-thumb" v-bind:src="provider.brandImage.secure_url">{{ provider.name }}</span>
									<!-- <span class="icon-check" style="float: right;"></span> -->
								</b-list-group-item>
							</b-list-group>
							<div v-else class="text-center">
								<div class="break-10"></div>
									Keine Elemente gefunden.
								<div class="break-10"></div>
							</div>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>				
	</b-container>
</template>

<script>
// Organize imports

export default {
	data: function() {
		return {
			query: '',
			selectedItem: '',
			selectedItemObject: '',
			foundItems: [],
			availableItems: [],
		};
	},
	methods: {
		searchItem: function() {
			// Clear search results
			this.foundItems = [];
			
			if(this.query !== '') {
				// Perform search
				for(var i = 0; i < this.availableItems.length; i++) {
					if(this.availableItems[i].name.toLowerCase().match(this.query.toLowerCase())) {
						if(!this.foundItems.includes(this.availableItems[i]) && this.availableItems[i] !== this.selectedItemObject) {
							this.foundItems.push(this.availableItems[i]);
						}
					}
				}				
			}
		},
		toggleSelect: function(provider) {
			if(this.selectedItem !== provider._id) {
				this.selectedItem = provider._id;
				this.query = '';
			}
		},
		getSelectedItemObject: function() {
			if(this.selectedItem !== '') {
				for(var i = 0; i < this.availableItems.length; i++) {
					if(this.availableItems[i]._id == this.selectedItem) {
						this.selectedItemObject = this.availableItems[i];
					}
				}				
			}
		},
		emitCoupon: function() {
			// Send the found provider to the parent element
			this.$emit('input', this.selectedItem);
		},
	},
	watch: {
		selectedItem: function() {
			this.emitCoupon();
			this.getSelectedItemObject();
		},
		value: function() {
			this.selectedItem = this.value;
		},
	},
	mounted: function() {
		this.$http.get("providers").then(function(result) {
			// Set found coupons to available items 
			this.availableItems = result.body

			// Get the object of the selected item
			this.selectedItem = this.value;
			this.getSelectedItemObject();
		});
	},
	props: ['value'],
}
</script>

<style scoped>
.map-wrapper {
	height: 250px;
}
.map-container {
	height: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.resultBox {
	border: 1px dashed rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
    display: block;
    width: 100%;
    padding: 18px 0px 18px 0px;
    font-size: 1rem;
    line-height: 1.25;
    color: #495057;
    cursor: pointer;
}
.list-group-item:HOVER {
	background-color: #ff6600;
	color: #ffffff;
}
.list-group-item-selected {
	background-color: #ff6600;
	color: #ffffff;
}
.brand-image-thumb {
	display: inline-block;
	width: 25px;
	height: 25px;
	
	margin-left: -10px;
	margin-right: 10px;
	
	border-radius: 50px 50px 50px 50px;
	-moz-border-radius: 50px 50px 50px 50px;
	-webkit-border-radius: 50px 50px 50px 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/98_ui/ProviderSelector.vue